import {
  Check,
  Close,
  Edit,
  North,
  South,
  VisibilityTwoTone,
} from "@mui/icons-material";
import React, { useState } from "react";
import { Container, Form, Table } from "react-bootstrap";
import {
  getComparator,
  stableSort,
} from "../../../../lib/utils";
import TableLoader from "../../TableLoader";
import AttachmentModal from "./AttachmentModal";
import CustomIconButton from "../../CustomIconButton";
import { isExecutiveManager } from "../../../../lib/userUtils";

const AttachmentTable = ({
  data,
  headerTabs,
  isLoading,
  editableFields,
  action,
  handleUpdateEntity,
  defaultSort,
  order,
  setOrder,
  isEditable = true,
}) => {
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingValues, setEditingValues] = useState({});
  const [orderBy, setOrderBy] = React.useState(defaultSort || "");
  const handleEditClick = (row) => {
    setEditingRowId(row.id);
    setEditingValues({ ...row });
  };
  const [showAttachment, setShowAttachment] = useState(false);
  const [defaultSelected, setDefaultSelected] = useState(0);
  const handleEditClose = () => {
    setEditingRowId(null);
    setEditingValues({});
  };

  const handleSaveClick = async (id) => {
    await handleUpdateEntity(id, {
      ...editingValues,
      file_name: editingValues.file_name.trim(),
    });
    setEditingRowId(null);
    setEditingValues({});
  };

  const handleClose = () => {
    setShowAttachment(false);
    setDefaultSelected(null);
  };

  const handleOpen = (id) => {
    setShowAttachment(true);
    setDefaultSelected(id);
  };

  const handleRowInputChange = (e, key) => {
    const { id, value, type, checked } = e.target;
    setEditingValues((prevValues) => ({
      ...prevValues,
      [key]: value,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const renderCellContent = (row, column) => {
    const { key, formatContent } = column;
    const value = formatContent
      ? formatContent(row)
      : editingRowId === row.id
        ? editingValues[key] ?? row[key]
        : row[key];
    if (editableFields?.includes(key) && editingRowId === row.id) {
      return (
        <Form.Control
          size="sm"
          type="text"
          value={value}
          onChange={(e) => handleRowInputChange(e, key)}
        />
      );
    } else {
      return value || 'N/A';
    }
  };
  const handleSort = (key) => {
    setOrder(order === "asc" ? "desc" : "asc");
    setOrderBy(key);
  };

  return (
    <Container
      fluid
      className="mt-4 d-flex justify-content-left align-items-center px-0"
    >
      <Table bordered striped className="border">
        <thead>
          <tr>
            {headerTabs?.map((tab) => (
              <th
                title={tab.hoverText || tab.label}
                className={tab?.sortable ? "cursor-pointer" : "cursor-arrow"}
                key={tab.key}
                onClick={tab?.sortable ? () => handleSort(tab.key) : () => { }}
              >
                {tab.label}{" "}
                {tab?.sortable && tab.key === orderBy ? (
                  order === "asc" ? (
                    <North />
                  ) : (
                    <South />
                  )
                ) : null}
              </th>
            ))}
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        {isLoading ? (
          <TableLoader
            colSpan={action ? headerTabs.length + 1 : headerTabs.length}
          />
        ) : (
          <tbody>
            {data?.length === 0 && (
              <tr>
                <td colSpan={headerTabs.length + 1} className="text-center">
                  No attachments added
                </td>
              </tr>
            )}
            {stableSort(data, getComparator(order, orderBy)).map(
              (row, rowIndex) => (
                <tr key={`row-${rowIndex}`}>
                  {headerTabs?.map((column, colIndex) => (
                    <td
                      key={`col-${colIndex}-${rowIndex}`}
                      align="left"
                      width={column.width}
                    >
                      {renderCellContent(row, column)}
                    </td>
                  ))}
                  <td className="row-action" align="left" width={100}>
                    {row.gainss_project_id !== null ? (
                      editingRowId === row.id ? (
                        <div className="d-flex">
                          <CustomIconButton
                            variant="success"
                            size="sm"
                            title={
                              editingValues.file_name
                                ? "Save Changes"
                                : "Please Add Name"
                            }
                            disabled={!editingValues.file_name}
                            disableRipple
                            onClick={() => handleSaveClick(row.id)}
                          >
                            <Check sx={{ color: "green" }} />
                          </CustomIconButton>
                          <CustomIconButton
                            variant="success"
                            size="sm"
                            title="Cancel"
                            disableRipple
                            onClick={() => handleEditClose()}
                          >
                            <Close sx={{ color: "#1b3f87" }} />
                          </CustomIconButton>
                        </div>
                      ) : (
                        <div className="d-flex">
                          {
                            !row.content_type.includes('image') ? <a
                              className="btn btn-success btn-sm" style={{
                                background: "transparent",
                                border: "none",
                                padding: '12px 8px'
                              }} href={row.url}
                              target="_blank"
                              rel="noreferrer"> <VisibilityTwoTone sx={{ color: "#1b3f87" }} /></a> :
                              <CustomIconButton
                                variant="success"
                                size="sm"
                                title="View attachment"
                                disableRipple
                                onClick={() => handleOpen(rowIndex)}
                              >
                                <VisibilityTwoTone sx={{ color: "#1b3f87" }} />
                              </CustomIconButton>

                          }
                          {isEditable && !isExecutiveManager() && (
                            <>
                              <CustomIconButton
                                variant="primary"
                                size="sm"
                                title="Edit"
                                disableRipple
                                onClick={() => handleEditClick(row)}
                              >
                                <Edit sx={{ color: "#1b3f87" }} />
                              </CustomIconButton>

                              {action && action(row)}
                            </>
                          )}
                        </div>
                      )
                    ) : null}
                  </td>
                </tr>
              )
            )}
          </tbody>
        )}
      </Table>
      <AttachmentModal
        show={showAttachment}
        handleClose={handleClose}
        attachments={stableSort(data, getComparator(order, orderBy))}
        defaultSelected={defaultSelected}
        setDefaultSelected={setDefaultSelected}
      />
    </Container>
  );
};

export default AttachmentTable;
